import { useState, useEffect } from 'react';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { _Appointment, _TaxSchemeContext } from '../../../../core/services/dataBean/EntityCatalog';

interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
}

export const SelectTaxSchemeContext = ({ idSelector, onChange, label }: Props) => {

    const { instance, lista, setLista } = useDataBean(_TaxSchemeContext)
    const [id, setID] = useState(null);

    useEffect(() => {
        setID(idSelector);
    }, [idSelector])

    useEffect(() => {
        setID(idSelector);
        getLista();
    }, [])

    const setValue = (e: any) => {
        setID(parseInt(e));
        onChange(e);
    }

    const getLista = () => {
        instance.getTaxSchemeContextCatalog(null).then(
            (resp) => {
                setLista(resp)
            }
        )
    }

    return (
        <>
            <label>{label ?? "Tipos de Esquemas de Impuestos"}</label>
            <select className="form-select" value={id} onChange={(e) => {
                const value = e.target.value? Number(e.target.value): null;
                setValue(value)
            }}>
                <option value={""}>...</option>
                {lista &&
                    lista.map((item: any) => {
                        return (
                            <option key={item.DataBeanProperties.IDTaxSchemeContext} value={item.DataBeanProperties.IDTaxSchemeContext} >{item.DataBeanProperties.Name} - {item.DataBeanProperties.SiteIDName}</option>
                        )
                    })
                }
            </select>
        </>
    )
}